















































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { TimesheetListModule } from "@/store/modules/timesheetList";
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import { AgencySettingsModule } from "@/store/modules/agencySettings";
import DeskDto from "@/models/Desks/DeskDto";
import ListUtils from "@/lib/listUtils";

@Component({
  name: "TimesheetListSearchCriteria",
})
export default class extends GiganautVueDialog {
  public dialog = false;
  public locationSearch: any = null;
    public datesFailedValidation = false;

  get searchOptions() {
    return TimesheetListModule.timesheetSearchViewModel;
  }

  get desks() {
    if (this.searchOptions.selectedBranch !== null && this.searchOptions.selectedBranch !== undefined) {
      return this.searchOptions.selectedBranch.desks;
    }
      return [];
  }

  get branches() {
    return AgencySettingsModule.branches;
  }

  get statuses() {
    return ListUtils.timesheetStatuses();
  }

  get loading() {
    return TimesheetListModule.loading;
  }

  async search() {
    if (!TimesheetListModule.timesheetSearchViewModel.startAtFromTo) {
      this.datesFailedValidation = true;
      return;
    }
    if (TimesheetListModule.timesheetSearchViewModel.startAtFromTo.length !== 2) {
      this.datesFailedValidation = true;
      return;
    }
    this.dialog = false;
    await TimesheetListModule.searchTimesheets();
  }
}
